// IM-EXT-004 — identificador aleatório para chaves de idempotência do cliente.
// Causa do erro "crypto.randomUUID is not a function": `randomUUID` só existe em CONTEXTO SEGURO (HTTPS ou localhost);
// o domínio ainda é servido em HTTP. `crypto.getRandomValues` existe em qualquer contexto e é criptograficamente forte:
// com ele se monta um UUID v4 (RFC 9562) — nunca Math.random (previsível). Os IDs persistentes continuam sendo gerados
// no banco (gen_random_uuid); este valor só identifica uma TENTATIVA de requisição.
type CryptoLike = { randomUUID?: () => string; getRandomValues?: <T extends Uint8Array>(a: T) => T };

export function newId(c: CryptoLike | undefined = (globalThis as { crypto?: CryptoLike }).crypto): string {
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  if (!c || typeof c.getRandomValues !== 'function') throw new Error('Gerador aleatório seguro indisponível neste navegador.');
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40; // versão 4
  b[8] = (b[8]! & 0x3f) | 0x80; // variante RFC 4122/9562
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
